import http from './index';

// 获取权限列表
export function perms(params) {
    return http({
        url: http.adornUrl('/useres/perms'),
        method: 'get',
        params: http.adornParams(params)
    })
}

// 登录
export function fLogin(data) {
    return http({
        url: http.adornUrl('/fLogin/fLogin'),
        method: 'post',
        data: http.adornData(data)
    })
}

// 注册
export function registerUser(data) {
    return http({
        url: http.adornUrl('/fLogin/registerUser'),
        method: 'post',
        data: http.adornData(data)
    })
}

// 获取用户信息
export function getUserInfo(params) {
    return http({
        url: http.adornUrl('/index/getUserInfo'),
        method: 'get',
        params: http.adornParams(params)
    })
}

// 获取首页信息查询数据
export function indexMes(params) {
    return http({
        url: http.adornUrl('/index/indexMes'),
        method: 'get',
        params: http.adornParams(params)
    })
}


// 获取首页列表（搜索、分类筛选）
export function indexSearch(params) {
    return http({
        url: http.adornUrl('/index/indexSearch'),
        method: 'post',
        data: http.adornData(params)
    })
}

// es全局搜索
export function esSearch(params) {
    return http({
        url: http.adornUrl('/index/esSearch'),
        method: 'get',
        params: http.adornParams(params)
    })
}

// 获取视频详情
export function getVideoDetail(params) {
    return http({
        url: http.adornUrl('/my/getVideoDetail'),
        method: 'get',
        params: http.adornParams(params)
    })
}

// 获取我上传视频
export function upload(params) {
    return http({
        url: http.adornUrl('/my/upload'),
        method: 'get',
        params: http.adornParams(params)
    })
}

// 获取我审核的视频
export function getMyReviewWk(params) {
    return http({
        url: http.adornUrl('/my/getMyReviewWk'),
        method: 'get',
        params: http.adornParams(params)
    })
}

// 获取我审核的视频
export function shareWorks(params) {
    return http({
        url: http.adornUrl('/my/shareWorks'),
        method: 'get',
        params: http.adornParams(params)
    })
}

// 通过/删除

export function modifyVideoStatus(data) {
    return http({
        url: http.adornUrl('/my/modifyVideoStatus'),
        method: 'post',
        data: http.adornData(data)
    })
}


//修改用户
export function userUpdate(data) {
    return http({
        url: http.adornUrl('/useres/update'),
        method: 'post',
        data: http.adornData(data)
    })
}

// 保存作品信息
export function videoInfo(data) {
    return http({
        url: http.adornUrl('/works/upload/videoInfo'),
        method: 'post',
        data: http.adornData(data)
    })
}

// 保存 经纪人联系人信息
export function contact(data) {
    return http({
        url: http.adornUrl('/works/upload/contact'),
        method: 'post',
        data: http.adornData(data),
    })
}

// 检验密码
export function checkPlayPassword(params) {
    return http({
        url: http.adornUrl('/my/checkPlayPassword'),
        method: 'get',
        params: http.adornParams(params),
    })
}

// 根据输入·信息查询艺术家信息
export function seachArtist(params) {
    return http({
        url: http.adornUrl('/works/upload/artist'),
        method: 'get',
        params: http.adornParams(params)
    })
}

// 保存艺术家信息
export function artist(data) {
    return http({
        url: http.adornUrl('/works/upload/artist'),
        method: 'post',
        data: http.adornData(data, true, 'file'),
    })
}


// 根据图片id获取图片对应url
export function cover(params) {
    return http({
        url: http.adornUrl('/works/upload/cover'),
        method: 'get',
        params: http.adornParams(params)
    })
}

// 获取当前步骤的草稿内容
export function draft(params) {
    return http({
        url: http.adornUrl('/works/upload/draft'),
        method: 'get',
        params: http.adornParams(params)
    })
}

// 保存草稿
export function saveDraft(data) {
    return http({
        url: http.adornUrl('/works/upload/draft/'+ data.worksId),
        method: 'post',
    })
}

// 封面上传
export function coverImg(data) {
    return http({
        url: http.adornUrl('/works/upload/coverImg/'+data.videoId),
        method: 'post',
    })
}

// 获取我的草稿列表
export function getMyDraftWk(params) {
    return http({
        url: http.adornUrl('/my/getMyDraftWk'),
        method: 'get',
        params: http.adornParams(params)
    })
}


// 获取全部分类
export function getTypeList(params) {
    return http({
        url: http.adornUrl('/type/getTypeList'),
        method: 'get',
        params: http.adornParams(params)
    })
}

// 获取全部标签
export function getTagList(params) {
    return http({
        url: http.adornUrl('/tags/getTagList'),
        method: 'get',
        params: http.adornParams(params)
    })
}


// 上传作品最后一页提交作品
export function submit(data) {
    return http({
        url: http.adornUrl('/works/upload/submit/'+data.worksId),
        method: 'POST',
    })
}

// 点击播放发送id用于后台记录
export function playSaveL(params) {
    return http({
        url: http.adornUrl('/index/playNum'),
        method: 'get',
        params: http.adornParams(params)
    })
}

// 根据图片id删除图片
export function deleteImg(data) {
    return http({
        url: http.adornUrl('/works/upload/delete'),
        method: 'post',
        data: http.adornData(data),
    })
}

//  通过分类获取标签信息
export function getTagsByTypeId(params) {
    return http({
        url: http.adornUrl('/tags/getTagsByTypeId'),
        method: 'get',
        params: http.adornParams(params)
    })
}

// 用户自定义标签
export function userTags(data) {
    return http({
        url: http.adornUrl('/tags/userTags?tagsName='+data.tagsName),
        method: 'post',
    })
}


// 删除用户自定义标签
export function removeTag(data) {
    return http({
        url: http.adornUrl('/tags/removeTag?id='+data.id),
        method: 'post',
    })
}

// 获取历史记录
export function searchHistory(params) {
    return http({
        url: http.adornUrl('/searchHistory/list'),
        method: 'get',
        params: http.adornParams(params)
    })
}


// 获取艺术家信息
export function getArtistMes(params) {
    return http({
        url: http.adornUrl('/artist/getArtistMes'),
        method: 'get',
        params: http.adornParams(params)
    })
}


//通过一级分类id，获取全部二三级分类请求方法 (用于响应式手机端分类展示 构思过后发现手机端展示目前只有这种方式能实现展示 故让后台在加请求接口)
export function getTypes(params) {
    return http({
        url: http.adornUrl('/app/type/getTypes'),
        method: 'get',
        params: http.adornParams(params)
    })
}

// 获取全部一级分类用于 （移动端）
export function getOneType(params) {
    return http({
        url: http.adornUrl('/app/type/getOneType'),
        method: 'get',
        params: http.adornParams(params)
    })
}
// 驳回作品
export function rejectWork(data) {
    return http({
        url: http.adornUrl('/my/rejectWork'),
        method: 'post',
        data: http.adornData(data),
    })
}

// 下载附件
export function downloadAnnex(params) {
    return http({
        url: http.adornUrl('/my/downloadAnnex'),
        method: 'get',
        params: http.adornParams(params)
    })
}

// 新入库列表
export function newInputList(data) {
    return http({
        url: http.adornUrl('/index/newInputList'),
        method: 'post',
        data: http.adornData(data),
    })
}

// 优秀作品
export function excellentVideoList(data) {
    return http({
        url: http.adornUrl('/index/excellentVideoList'),
        method: 'post',
        data: http.adornData(data),
    })
}




// WEBPACK FOOTER //
// ./src/api/api.js